(() => {
  const tabTrigger = $("[data-tabs-trigger]");
  const tabContainer = $("[data-tabs-container]");
  const classes = {
    TAB_ACTIVE: "active",
    APLICATION: "active"
  };
  const tabsInit = event => {
    const that = $(event.target);
    const thatId = that.attr("data-tabs-trigger");
    const container = $(`[data-tabs-container=${thatId}]`);
    const mainContainer = $(".c-box-home-tabs");

    mainContainer.removeClass(classes.APLICATION);
    tabTrigger.not(that).removeClass(classes.TAB_ACTIVE);
    tabTrigger.css("pointer-events", "none");

    tabContainer
      .fadeOut(150)
      .promise()
      .done(() => {
        container.stop(true, true).fadeIn(150);
        tabTrigger.css("pointer-events", "auto");
      });

    if (thatId === "home_tab_1") {
      mainContainer.addClass(classes.APLICATION);
    }

    that.addClass(classes.TAB_ACTIVE);
  };

  tabTrigger.on("click", tabsInit);

  tabTrigger.eq(0).trigger("click");
})();
